import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'wonderbly-components/lib/Grid';
import InterestOption from './InterestOption';

const Interest = props => (
  <Row className="cols-to-rows-on-mobile">
    {props.items.map(option => (
      <Col
        className="col-1-4-on-desktop-up col-1-2-on-fablet-and-tablet interest-option-column"
        key={option.id}>
        <InterestOption
          {...option}
          onFormikSubmit={props.onFormikSubmit}
          isSelected={props.productCustomisation[props.interestType] === option.id}
          optionName={props.interestType}
        />
      </Col>
    ))}
  </Row>
);

Interest.propTypes = {
  onFormikSubmit: PropTypes.func.isRequired,
  productCustomisation: PropTypes.object.isRequired,
  interestType: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
    }),
  ),
};

export default Interest;



// WEBPACK FOOTER //
// ./src/client/js/view/components/CreationForm/Interest/Interest.js